//Form Validation for submission
import { isDateValid } from "../../common";
const Validator = require("validator");
const isEmpty = require("../../common/functions/is-empty");

export function validateRequestInput(data, approversEmailList, role) {
  let validationErrors = {};

  data.department = !isEmpty(data.department) ? data.department : "";
  data.businessUnit = !isEmpty(data.businessUnit) ? data.businessUnit : "";
  data.email = !isEmpty(data.email) ? data.email : "";
  data.purpose = !isEmpty(data.purpose) ? data.purpose : "";
  data.endUserLocation = !isEmpty(data.endUserLocation)
    ? data.endUserLocation
    : "";
  data.executiveChefEmail = !isEmpty(data.executiveChefEmail)
    ? data.executiveChefEmail
    : "";
  data.HODDepartment = !isEmpty(data.HODDepartment) ? data.HODDepartment : "";
  data.needByDate = !isEmpty(data.needByDate) ? data.needByDate : "";

  //check if date is valid
  if (!isDateValid(data.needByDate)) {
    validationErrors.needByDate = "Need By Date field should be a valid date";
  }

  if (
    role === "procurement" &&
    approversEmailList.includes(data.email.toLowerCase())
  ) {
    validationErrors.email = "Chef Email can't be Executive Chef or HOD";
  }

  // checks if email is email
  if (!Validator.isEmail(data.email)) {
    validationErrors.email = "Email is invalid";
  }
  if (!Validator.isEmail(data.executiveChefEmail)) {
    validationErrors.executiveChefEmail = "Email is invalid";
  }

  // checks if a field is empty
  if (Validator.isEmpty(data.department)) {
    validationErrors.department = "Department  is required";
  }
  if (Validator.isEmpty(data.businessUnit)) {
    validationErrors.businessUnit = "Business Unit  is required";
  }
  if (Validator.isEmpty(data.email)) {
    validationErrors.email = "Email field is required";
  }
  if (Validator.isEmpty(data.purpose)) {
    validationErrors.purpose = "Purpose is required";
  }
  if (Validator.isEmpty(data.endUserLocation)) {
    validationErrors.endUserLocation = "End User Location is required";
  }
  if (Validator.isEmpty(data.executiveChefEmail)) {
    validationErrors.executiveChefEmail =
      "Executive Chef Email field is required";
  }
  if (Validator.isEmpty(data.HODDepartment)) {
    validationErrors.HODDepartment = "HOD field is required";
  }
  if (Validator.isEmpty(data.needByDate)) {
    validationErrors.needByDate = "Need By Date is required";
  }

  return {
    validationErrors,
    isValid: isEmpty(validationErrors),
  };
}
